"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginPasswordStrength = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _react = require("react");

var _TagAndInput = require("../TagAndInput");

var _jsxRuntime = require("react/jsx-runtime");

var LoginPasswordStrength = function LoginPasswordStrength(_ref) {
  var emptyPassword = _ref.emptyPassword,
      emptyConfirmPassword = _ref.emptyConfirmPassword,
      matchPasswords = _ref.matchPasswords,
      required = _ref.required;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      passwordStrength = _useState2[0],
      setPasswordStrength = _useState2[1];

  var upperCaseLetters = /[A-Z]/g;
  var numbers = /[0-9]/g;
  var specialChar = /[‘!’,‘@’,‘#’,‘$’,‘%’,‘^’,‘&’,‘*’]/g;

  var updateInfo = function updateInfo(e) {
    switch (e.target.id) {
      case "newPasswordInput":
        setPasswordStrength(0);

        if (e.target.value.length >= 8) {
          setPasswordStrength(function (passwordStrength) {
            return passwordStrength + 1;
          });
        } //Verificar si la contraseña contiene mayuscula, numeros y un caracter especial


        e.target.value.match(upperCaseLetters) && setPasswordStrength(function (passwordStrength) {
          return passwordStrength + 1;
        });
        e.target.value.match(numbers) && setPasswordStrength(function (passwordStrength) {
          return passwordStrength + 1;
        });
        e.target.value.match(specialChar) && setPasswordStrength(function (passwordStrength) {
          return passwordStrength + 1;
        });
        break;

      default:
        return;
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "user",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TagAndInput.TagAndInput, {
        inputType: "password",
        inputId: "newPasswordInput",
        label: "Ingrese su nueva contraseña",
        isRequired: required,
        inputOnChange: updateInfo
      }), emptyPassword && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
        children: "La contrase\xF1a debe ser minimo de 8 caracteres"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "divPasswordStrength",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ItemPasswordStrength, {
        paso: 1,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Password, {
          level: 1,
          passwordStrength: passwordStrength
        }), passwordStrength === 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Baja"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ItemPasswordStrength, {
        paso: 2,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Password, {
          level: 2,
          passwordStrength: passwordStrength
        }), passwordStrength === 2 && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Regular"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ItemPasswordStrength, {
        paso: 3,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Password, {
          level: 3,
          passwordStrength: passwordStrength
        }), passwordStrength === 3 && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Segura"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ItemPasswordStrength, {
        paso: 4,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Password, {
          level: 4,
          passwordStrength: passwordStrength
        }), passwordStrength === 4 && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Fuerte"
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "user",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TagAndInput.TagAndInput, {
        inputType: "password",
        inputId: "confirmPasswordInput",
        label: "Confirme la nueva contraseña",
        isRequired: required
      }), emptyConfirmPassword && !emptyPassword && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
        children: "Confirme la contrase\xF1a"
      }), !emptyConfirmPassword && !emptyPassword && !matchPasswords && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
        children: "La contrase\xF1a no coincide"
      })]
    })]
  });
};

exports.LoginPasswordStrength = LoginPasswordStrength;